<template>
   <div>
       <keep-alive>
           <component :is="showProductComponent"  :product="order"></component>
       </keep-alive>
   </div>
</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import params from "~/config/params";
    export default {
        mixins:[OrderMixin],
        props:{
            order:{
                required: true,
                type:Object
            },
        },
        data(){
            return {
                showProductComponent:'',
                productMap:[
                    {code:params.ZUJUAN_PRODUCT_CODE,name:'组卷',component:'Homework'},
                    {code:params.ZUJUANCOR_PRODUCT_CODE,name:'组卷合作机构',component:'zj-cooperate'},
                    {code:params.XWT_PRODUCT_CODE,name:'校网通',component:'xwt'},
                    {code:params.XB_PRODUCT_CODE,name:'校本资源库',component:'jbzyk'},
                    {code:params.XB3_PRODUCT_CODE,name:'校本3.0',component:'jiaoben3'},
                    {code:params.OFFICIAL_WEBSITE_PRODUCT_CODE,name:'门户官网',component:'website'},
                    {code:params.DIGITIZEDCAMPUS_PRODUCT_CODE,name:'数字化校园',component:'szhxy'},
                ]
            }
        },
        created(){
            let product = this.productMap.find(i=>{return i.code == this.order.product_code });
            if(!product) return  this.showProductComponent='Paike'
            this.showProductComponent = product.component;
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_product.vue